jQuery(document).ready(function() {

      
  
  // Hero Slider
  jQuery('.top-thumb-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 12,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 979,
        settings: {
          arrows: false,
          dots: false
        }
      }
    ]
  });

  // Product Slider
  jQuery('.feature-collection-home .index--collection--root .featured-collections--body').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 979,
        settings: {
          arrows: true,
          dots: false
        }
      }
    ]
  });

  // FAQ section
jQuery('.service-list--info').click(function() {
  var accordionContent = jQuery(this).next('.service-list--description');
  
  if (accordionContent.is(':visible')) {
    accordionContent.slideUp();
    jQuery(this).removeClass('active');
  } else {
    jQuery('.service-list--description').slideUp();
    accordionContent.slideDown();
    jQuery(this).addClass('active');
  }
});

  




});
// end of document ready

// collection dropdown
  const dropdown = document.getElementById('dropdown');
        dropdown.addEventListener('change', function() {
            const selectedValue = dropdown.value;
            if (selectedValue) {
                window.location.href = selectedValue;
            }
});